import { convertDate } from '@/common/util';

class WorldRecord {
    constructor(record) {
        this.order = record.order;
        if (record.gwr === true)
            this.order += "**";
        else if (record.pr === true)
            this.order += "*";

        this.event = record.event;
        this.division = record.division;
        this.time = record.time;
        this.date = convertDate(record.date);
        this.location = record.location;
        this.video = record.video;
        this.tags = record.tags;
        if (!this.tags)
            this.tags = [];
    }
}

function fetchMappedRecords() {
    return fetch("https://jonscannell-com.firebaseio.com/worldRecords.json")
        .then(response => response.json())
        .then(data => data.map(record => new WorldRecord(record)));
}

export { fetchMappedRecords };